import type { LocationSuggestOption, MultiLocationSuggestOption } from '@construct-kit/core';
import reportError from '../client/tracking/errorReporter';

export const requestSource = 'rca-listing-ui';
export const LOCATION_SUGGEST_API =
  'https://suggest.realestate.com.au/consumer-suggest/suggestions';

export type LocationType =
  | 'suburb'
  | 'postcode'
  | 'region'
  | 'precinct'
  | 'state'
  | 'address'
  | 'street'
  | 'listing';

export type LocationSuggestionParams = {
  locationTypes: LocationType[];
  locationQuery: string;
  maxResults?: number;
};

export const locationTypeArray: LocationType[] = [
  'suburb',
  'region',
  'precinct',
  'state',
  'postcode',
];

export const fetchLocationSuggestions = async ({
  locationTypes,
  locationQuery,
  maxResults = 5,
}: LocationSuggestionParams): Promise<
  MultiLocationSuggestOption[] | LocationSuggestOption[] | undefined
> => {
  const params = [
    ['max', maxResults.toString()],
    ['type', locationTypes.join(',')],
    ['src', requestSource],
    ['query', locationQuery],
  ];

  const url = new URL(LOCATION_SUGGEST_API);
  params.forEach((param) => url.searchParams.set(param[0], param[1]));

  const response = await fetch(`${url}`);
  const data = (await response.json()) as {
    errors: Error[];
    error: Error;
    _embedded: { suggestions: MultiLocationSuggestOption[] | LocationSuggestOption[] };
  };

  if (data.errors || data.error) {
    reportError('failed to get Location Suggest data');
    return undefined;
  }
  // eslint-disable-next-line no-underscore-dangle
  return data._embedded.suggestions;
};
